export default __webpack_public_path__ + "static/media/02.b1f75b36.jpg";